export default __webpack_public_path__ + "static/media/019-pipe-1.5d2f9c67.png";